import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { isNil } from '@flex-design-system/fx-utils';
import { styled } from '@flex-design-system/stitches-react';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { FieldBoxContent } from './components/content/Content.mjs';
import { FieldBoxSlot } from './components/slot/Slot.mjs';
import { fieldBox } from './fieldBox.vanilla.mjs';
import { getDisabledAttribute } from './utils/attribute.mjs';

const FieldBoxImpl = forwardRef(
  ({
    children,
    className: classNameFromProps,
    disabled,
    leftSlot,
    rightSlot,
    size,
    state,
    variant,
    ...props
  }, forwardedRef) => {
    const className = classNames(
      fieldBox({ size, state, variant }),
      classNameFromProps
    );
    const content = isNil(leftSlot) && isNil(rightSlot) ? children : /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(FieldBoxSlot, { children: leftSlot }),
      /* @__PURE__ */ jsx(FieldBoxContent, { children }),
      /* @__PURE__ */ jsx(FieldBoxSlot, { children: rightSlot })
    ] });
    return /* @__PURE__ */ jsx(
      StyledDiv,
      {
        "data-scope": "field-box",
        "data-part": "root",
        className,
        ...getDisabledAttribute(disabled),
        ref: forwardedRef,
        ...props,
        children: content
      }
    );
  }
);
const StyledDiv = styled(Primitive.div);
const FieldBox = Object.assign({}, styled(FieldBoxImpl), {
  Content: styled(FieldBoxContent),
  /**
   * @deprecated
   * `FieldBox.Slot`을 사용해 주세요.
   */
  LeftSlotRoot: styled(FieldBoxSlot),
  /**
   * @deprecated
   * `FieldBox.Slot`을 사용해 주세요.
   */
  RightSlotRoot: styled(FieldBoxSlot),
  Slot: styled(FieldBoxSlot)
});
FieldBox.displayName = "FieldBox";

export { FieldBox };
//# sourceMappingURL=FieldBox.mjs.map
